import React, { useState } from "react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { useAuth } from "../../context/AuthContext";
import { updateProfile, updatePassword } from "../../services/profileService";

const Profile = () => {
  const { user, setUser } = useAuth();

  const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "", phone: user?.phone || "" });
  const [avatar, setAvatar] = useState(null);
  const [status, setStatus] = useState("");

  const [pwForm, setPwForm] = useState({ current_password: "", password: "", password_confirmation: "" });
  const [pwStatus, setPwStatus] = useState("");

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setStatus("সেভ হচ্ছে...");
    try {
      const payload = { ...form };
      if (avatar) payload.avatar = avatar;
      const data = await updateProfile(payload);
      setUser(data.user);
      setStatus("প্রোফাইল আপডেট হয়েছে।");
    } catch (err) {
      setStatus(err?.response?.data?.message || "আপডেট করা যায়নি।");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPwStatus("সেভ হচ্ছে...");
    try {
      await updatePassword(pwForm);
      setPwForm({ current_password: "", password: "", password_confirmation: "" });
      setPwStatus("Password পরিবর্তন হয়েছে।");
    } catch (err) {
      setPwStatus(err?.response?.data?.errors?.current_password?.[0] || "Password পরিবর্তন করা যায়নি।");
    }
  };

  return (
    <React.Fragment>
      <Header parentMenu="profile" activeMenu="/profile" />
      <SiteBreadcrumb pageTitle="My Profile" pageName="My Profile" breadcrumbsImg={bannerbg} />

      <section style={{ padding: "80px 0" }}>
        <div className="container" style={{ maxWidth: 520 }}>
          <h4>প্রোফাইল তথ্য</h4>
          {status && <p>{status}</p>}
          <form onSubmit={handleProfileSubmit}>
            <div className="contact-one__input-box">
              <input
                type="text"
                placeholder="নাম"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
              />
            </div>
            <div className="contact-one__input-box">
              <input
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>
            <div className="contact-one__input-box">
              <input
                type="text"
                placeholder="ফোন"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>
            <div className="contact-one__input-box">
              <input type="file" accept="image/*" onChange={(e) => setAvatar(e.target.files[0])} />
            </div>
            <button type="submit" className="thm-btn contact-one__btn">
              সেভ করুন
            </button>
          </form>

          <hr style={{ margin: "40px 0" }} />

          <h4>Password পরিবর্তন করুন</h4>
          {pwStatus && <p>{pwStatus}</p>}
          <form onSubmit={handlePasswordSubmit}>
            <div className="contact-one__input-box">
              <input
                type="password"
                placeholder="বর্তমান Password"
                value={pwForm.current_password}
                onChange={(e) => setPwForm({ ...pwForm, current_password: e.target.value })}
                required
              />
            </div>
            <div className="contact-one__input-box">
              <input
                type="password"
                placeholder="নতুন Password"
                value={pwForm.password}
                onChange={(e) => setPwForm({ ...pwForm, password: e.target.value })}
                required
              />
            </div>
            <div className="contact-one__input-box">
              <input
                type="password"
                placeholder="নতুন Password (আবার লিখুন)"
                value={pwForm.password_confirmation}
                onChange={(e) => setPwForm({ ...pwForm, password_confirmation: e.target.value })}
                required
              />
            </div>
            <button type="submit" className="thm-btn contact-one__btn">
              Password পরিবর্তন করুন
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Profile;
